import { gql } from 'apollo-angular';

export const FillPublicFirstStepDocument = gql`
  mutation fillPublicFirstStep($input: StatementFirstInputGraphql!) {
    fillPublicFirstStep(input: $input)
  }
`;
